<div class="dialog-backdrop" *ngIf="isVisible" (click)="handleBackdropClick($event)">
  <div class="ip-whitelist-dialog">
    <!-- Header Section -->
    <div class="dialog-header">
      <h2 class="dialog-title">{{ dialogTitle }}</h2>
      <p class="dialog-description">{{ dialogDescription }}</p>
    </div>

    <!-- Form Section -->
    <div class="dialog-body">
      <form (ngSubmit)="handleSubmit()" class="form-groups">
        <!-- Merchant Name (Edit mode — disabled display) -->
        <div class="form-group" *ngIf="mode === 'edit' && showMerchantInfo">
          <label for="merchantDisplay" class="form-label">
            Merchant Name
          </label>
          <input
            type="text"
            id="merchantDisplay"
            class="form-input"
            [value]="merchantDisplay"
            disabled="true"
          />
        </div>

        <!-- Merchant lookup (add mode, PAY10 Admin only) -->
        <div class="form-group" *ngIf="mode === 'add' && showMerchantSearch">
          <label for="merchantQuery" class="form-label">
            Merchant Name or Merchant ID
          </label>
          <div class="merchant-search-field" [ngClass]="{ 'invalid': merchantError }">
            <input
              type="text"
              id="merchantQuery"
              name="merchantQuery"
              class="merchant-search-input"
              [(ngModel)]="merchantQuery"
              [disabled]="isValidatingMerchant"
              [attr.aria-invalid]="merchantError"
              placeholder="Enter merchant name or ID"
            />
            <button type="button" class="merchant-search-icon-btn"
              [disabled]="!merchantQuery.trim() || isValidatingMerchant"
              (click)="searchMerchant()"
              aria-label="Search merchant">
              <i class="pe-7s-search"></i>
            </button>
          </div>
          <div class="field-error" *ngIf="merchantError">
            <span class="error-icon">!</span>
            <span>{{ merchantError }}</span>
          </div>
          <div class="merchant-confirm" *ngIf="validatedMerchant">
            ✓ {{ validatedMerchant.merchantName }} ({{ validatedMerchant.merchantId }}) is a valid merchant.
          </div>
        </div>

        <!-- IP Address Input -->
        <div class="form-group">
          <label for="ipAddress" class="form-label">
            IP Addresses <span class="required">*</span>
          </label>
          <input
            type="text"
            id="ipAddress"
            name="ipAddress"
            class="form-input"
            [(ngModel)]="formData.ipAddress"
            (ngModelChange)="validateIPAddress()"
            placeholder="Enter IP Address"
            required
            [attr.aria-required]="true"
          />
          <div *ngIf="ipAddressError !== null" class="error-message" >{{ipAddressError}}</div>
        </div>

        <!-- Name/Tag Input -->
        <div class="form-group">
          <label for="name" class="form-label">
            Name/Tag
          </label>
          <input
            type="text"
            id="name"
            name="name"
            class="form-input"
            [(ngModel)]="formData.name"
            placeholder="Enter Name or Tag (Optional)"
            maxlength="150"
          />
        </div>
      </form>
    </div>

    <!-- Actions Section -->
    <div class="dialog-actions">
      <button 
        type="button"
        class="btn-primary"
        [disabled]="!isFormValid()"
        (click)="handleSubmit()">
        {{ submitButtonText }}
      </button>
      <button 
        type="button"
        class="btn-secondary"
        (click)="handleCancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
